import { Modal, ModalContent, ModalHeader, ModalBody } from "@heroui/react";
import { useTranslation } from "react-i18next";

import { WorkflowSettings } from "./WorkflowSettings";

interface ChatSettingsModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ChatSettingsModal({ isOpen, onOpenChange }: ChatSettingsModalProps) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} size="5xl" onOpenChange={onOpenChange}>
      <ModalContent>
        <>
          <ModalHeader className="flex flex-col gap-1">{t("Configuration")}</ModalHeader>
          <ModalBody>
            <div className="flex flex-col gap-4 max-h-120 overflow-y-scroll px-6">
              {/* <ChatMetrics tokenUsage={tokenUsage} /> */}
              <WorkflowSettings isOpen={isOpen} />
              {/* <Speech /> */}
            </div>
          </ModalBody>
        </>
      </ModalContent>
    </Modal>
  );
}
